class GiftWrappingController {
  /* 2026-09-24: jedno odświeżenie na serię zmian w szufladzie (300 ms), jeden odczyt koszyka dla wszystkich trzech sprawdzeń
     i pamięć tagów produktów — wcześniej każda zmiana w szufladzie wysyłała 3× /cart.js + 3× /products/*.js na pozycję,
     a równoległe zapisy koszyka nadpisywały zmiany innych skryptów (np. prezentu PonyGadget) */
  /* perf 30.09 B-13, B-18: stan koszyka i tagi produktów czytamy z szuflady (script[data-sv-gw-state] w snippets/cart-drawer.liquid,
     przerysowywany razem z nią), więc przy odsłonie i po zmianie w szufladzie nie ma już GET /cart.js ani GET /products/<handle>.js
     na każdą pozycję. Pusty koszyk = żadnego zapisu (wcześniej każdy nowy gość dostawał POST /cart/update.js, czyli zakładany
     koszyk). Atrybut gift_wrapping_available jedzie do kasy polem formularza szuflady; skrypt zapisuje go sam tylko na stronie /cart
     (jej formularz tego pola nie ma) i tylko przy niepustym koszyku. Bez szuflady na stronie: odczyt z Cart API jak dotąd. */
  constructor() {
    this.isProcessing = false;
    this.tagCache = new Map();
    this.refreshTimer = null;
    this.refreshing = false;
    this.refreshAgain = false;
    this.canWriteAttribute = false;
    this.refresh();
    this.setupListeners();
  }

  scheduleRefresh() {
    clearTimeout(this.refreshTimer);
    this.refreshTimer = setTimeout(() => this.refresh(), 300);
  }

  async refresh() {
    if (this.refreshing) {
      this.refreshAgain = true;
      return;
    }
    this.refreshing = true;
    try {
      const state = this.readDrawerState() || (await this.fetchState());
      this.canWriteAttribute = state.count > 0 && !!document.getElementById('main-cart-items');
      this.checkCartEligibility(state);
      this.hideIncompatibleProducts(state);
      await this.autoRemoveIncompatibleGiftBag(state);
    } catch (error) {
      console.error('Gift wrapping check error:', error);
      this.canWriteAttribute = false;
      this.showGiftWrapping();
      this.showIncompatibleProducts();
    } finally {
      this.refreshing = false;
      if (this.refreshAgain) {
        this.refreshAgain = false;
        this.scheduleRefresh();
      }
    }
  }

  /* stan z szuflady: { count, attr, items: [{ id, bag, small }] }; brak = null */
  readDrawerState() {
    const element = document.querySelector('cart-drawer script[data-sv-gw-state]');
    if (!element) return null;
    try {
      const state = JSON.parse(element.textContent);
      return state && Array.isArray(state.items) ? state : null;
    } catch (error) {
      return null;
    }
  }

  /* strona bez szuflady: odczyt z Cart API i tagi z /products/<handle>.js (jak dotąd); pusty koszyk na /cart = bez zapytań */
  async fetchState() {
    const cartItems = document.querySelector('cart-items');
    if (cartItems && cartItems.classList.contains('is-empty')) return { count: 0, attr: null, items: [] };
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const productChecks = await Promise.all(cart.items.map(item => this.getProductTags(item.handle)));
    return {
      count: cart.item_count,
      attr: cart.attributes ? cart.attributes.gift_wrapping_available : null,
      items: cart.items.map((item, index) => {
        const tags = productChecks[index] || [];
        return {
          id: item.id,
          bag: tags.includes('gift_wrapping_product'),
          small: tags.includes('no_gift_wrapping')
        };
      })
    };
  }

  checkCartEligibility(state) {
    /* zapamiętaj bieżącą wartość atrybutu, żeby nie zapisywać koszyka przy każdej zmianie w szufladzie */
    this.lastGiftWrapAttr = state.attr === null ? undefined : state.attr;

    if (state.count === 0) {
      this.showGiftWrapping();
      return;
    }

    const allProductsAreIncompatible = state.items.every(item => item.small);

    if (allProductsAreIncompatible) {
      this.hideGiftWrapping();
    } else {
      this.showGiftWrapping();
    }
  }

  getProductTags(handle) {
    if (!this.tagCache.has(handle)) {
      const request = fetch(`/products/${handle}.js`)
        .then(response => response.json())
        .then(product => product.tags || [])
        .catch(error => {
          console.error(`Error fetching product ${handle}:`, error);
          this.tagCache.delete(handle);
          return [];
        });
      this.tagCache.set(handle, request);
    }
    return this.tagCache.get(handle);
  }

  hideGiftWrapping() {
    const giftWrappingProducts = document.querySelectorAll('[data-gift-wrapping-product="true"]');

    giftWrappingProducts.forEach(element => {
      const parentCard = element.closest('.card-wrapper, .grid__item, .product-card, .cart-item, .product-card-wrapper');
      if (parentCard) {
        parentCard.style.display = 'none';
      }
    });

    this.hideCartDrawerElements();
    this.updateCheckoutAttribute('gift_wrapping_available', 'no');
  }

  showGiftWrapping() {
    const giftWrappingProducts = document.querySelectorAll('[data-gift-wrapping-product="true"]');

    giftWrappingProducts.forEach(element => {
      const parentCard = element.closest('.card-wrapper, .grid__item, .product-card, .cart-item, .product-card-wrapper');
      if (parentCard) {
        parentCard.style.display = '';
      }
    });

    const notice = document.querySelector('.gift-wrapping-notice');
    if (notice) {
      notice.remove();
    }

    this.showCartDrawerElements();
    this.updateCheckoutAttribute('gift_wrapping_available', 'yes');
  }

  hideCartDrawerElements() {
    const checkboxContainer = document.querySelector('.cart-upsell-toggle-container');
    if (checkboxContainer) {
      checkboxContainer.style.display = 'none';
    }

    const giftWrappingItems = document.querySelectorAll('.cart-drawer-upsell-list-item[data-gift-wrapping-product="true"]');
    giftWrappingItems.forEach(item => {
      item.style.display = 'none';
    });
  }

  showCartDrawerElements() {
    const checkboxContainer = document.querySelector('.cart-upsell-toggle-container');
    if (checkboxContainer) {
      checkboxContainer.style.display = '';
    }

    const giftWrappingItems = document.querySelectorAll('.cart-drawer-upsell-list-item[data-gift-wrapping-product="true"]');
    giftWrappingItems.forEach(item => {
      item.style.display = '';
    });
  }

  hideIncompatibleProducts(state) {
    if (state.count === 0) {
      this.showIncompatibleProducts();
      return;
    }

    const hasGiftBag = state.items.some(item => item.bag);

    const hasOtherProducts = state.items.some(item => !item.bag);

    if (hasGiftBag && !hasOtherProducts) {
      const items = document.querySelectorAll('.cart-drawer-upsell-list-item[data-no-gift-wrapping="true"]');
      items.forEach(item => {
        item.style.display = 'none';
      });
    } else {
      this.showIncompatibleProducts();
    }
  }

  showIncompatibleProducts() {
    const items = document.querySelectorAll('.cart-drawer-upsell-list-item[data-no-gift-wrapping="true"]');
    items.forEach(item => {
      item.style.display = '';
    });
  }

  async autoRemoveIncompatibleGiftBag(state) {
    if (this.isProcessing) return;

    try {
      this.isProcessing = true;

      if (state.count === 0) {
        this.isProcessing = false;
        return;
      }

      const hasGiftBag = state.items.some(item => item.bag);

      const hasSmallProduct = state.items.some(item => item.small);

      const hasOtherProducts = state.items.some(item => !item.bag && !item.small);

      if (hasGiftBag && hasSmallProduct && !hasOtherProducts) {
        const giftBagItem = state.items.find(item => item.bag);

        if (giftBagItem) {
          const removeResponse = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: giftBagItem.id,
              quantity: 0,
              sections: this.sectionIds(),
              sections_url: window.location.pathname
            })
          });

          if (removeResponse.ok) {
            /* perf 30.09: przerysowanie z sekcji z odpowiedzi. Wcześniej renderContents() dostawał /cart.js bez sekcji i rzucał
               błąd, więc torba zostawała w szufladzie do następnej zmiany. Szuflada się przy tym nie otwiera (jak w cart-gift.js). */
            const data = await removeResponse.json();
            this.renderSections(data.sections);
          }
        }
      }
    } catch (error) {
      console.error('Error auto-removing gift bag:', error);
    } finally {
      setTimeout(() => {
        this.isProcessing = false;
      }, 500);
    }
  }

  sectionIds() {
    const ids = ['cart-drawer', 'cart-icon-bubble'];
    ['main-cart-items', 'main-cart-footer'].forEach(id => {
      const element = document.getElementById(id);
      if (element && element.dataset.id) ids.push(element.dataset.id);
    });
    return ids;
  }

  renderSections(sections) {
    if (!sections) return;
    const parse = html => new DOMParser().parseFromString(html, 'text/html');

    const drawer = document.querySelector('cart-drawer');
    const active = document.activeElement;
    const hadFocus = !!(drawer && active && active !== document.body && drawer.contains(active));
    if (drawer && sections['cart-drawer']) {
      const fresh = parse(sections['cart-drawer']).querySelector('.drawer__inner');
      const current = drawer.querySelector('.drawer__inner');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        drawer.classList.toggle('is-empty', !current.querySelector('.cart-item'));
      }
    }
    /* fokus zniknął razem z przerysowaną treścią: nazwa pierwszej pozycji, jak w motywie (cart.js) i cart-gift.js */
    if (hadFocus && (!document.activeElement || document.activeElement === document.body)) {
      const target = drawer.querySelector('.cart-item__name') || drawer.querySelector('.drawer__close');
      if (target && drawer.classList.contains('active') && typeof trapFocus === 'function') trapFocus(drawer, target);
      else if (target) target.focus();
    }

    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const fresh = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (fresh) bubble.innerHTML = fresh.innerHTML;
    }

    ['main-cart-items', 'main-cart-footer'].forEach(id => {
      const element = document.getElementById(id);
      if (!element || !element.dataset.id || !sections[element.dataset.id]) return;
      const source = parse(sections[element.dataset.id]).querySelector('.js-contents');
      const target = element.querySelector('.js-contents');
      if (source && target) target.innerHTML = source.innerHTML;
    });
  }

  updateCheckoutAttribute(key, value) {
    /* perf 30.09 B-13: bez zapisu przy pustym koszyku i poza stroną /cart (szuflada wysyła pole z formularzem kasy) */
    if (!this.canWriteAttribute) return;
    if (key === 'gift_wrapping_available' && this.lastGiftWrapAttr === value) return;
    if (key === 'gift_wrapping_available') this.lastGiftWrapAttr = value;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { [key]: value }
      })
    }).catch(err => console.error('Cart update error:', err));
  }

  setupListeners() {
    document.addEventListener('cart:updated', () => this.scheduleRefresh());
    document.addEventListener('shopify:section:load', () => this.scheduleRefresh());
    this.observeCartDrawer();
  }

  observeCartDrawer() {
    /* perf 30.09 B-13 (J4): zmiany wewnątrz gwiazdek Judge.me i kart „Dopełnij zestaw” (przepisywanie gwiazdek po wczytaniu,
       wybór koloru) nie są zmianą koszyka — wcześniej dawały drugie odświeżenie na każdej odsłonie */
    const observer = new MutationObserver(mutations => {
      const relevant = mutations.some(m => !(m.target.closest && m.target.closest('.jdgm-prev-badge, .jdgm-widget, .sv-xs-card')));
      if (relevant) this.scheduleRefresh();
    });
    const cartDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new GiftWrappingController();
  });
} else {
  new GiftWrappingController();
}
